module.exports = __webpack_public_path__ + "img/lasource-38.3a102942.jpg";